import React from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import ToggleComponent from "@common/components/shared/forms/ToggleComponent";
import TextareaComponent from "../forms/TextareaComponent";
import AgeVerificationAction from "@common/redux/actions/AgeVerificationAction";

const CustomerHasNoIdForm = () => {
  const {
    register,
    control,
    formState: { errors },
    watch,
  } = useFormContext();

  // Two flags controlled from System Admin in CMS Desktop:
  const {
    config: { hasChildrenInGamingArea, hasNoIdCustomerDescription },
  } = useSelector((state) => AgeVerificationAction.getStatePath(state));

  const [hasGambled, childrenInArea, requestedRemoveChild] = watch([
    "hasGambled",
    "childrenInArea",
    "requestedRemoveChild",
  ]);

  return (
    <>
      {hasChildrenInGamingArea && (
        <>
          <ToggleComponent
            control={control}
            name="childrenInArea"
            label="Is there children in the area?"
            error={errors.childrenInArea}
          />

          {childrenInArea && (
            <>
              <ToggleComponent
                control={control}
                name="requestedRemoveChild"
                label="Confirm you have requested parents remove child from area?"
                error={errors.requestedRemoveChild}
              />
              {requestedRemoveChild === false && (
                <TextareaComponent
                  name="reasonNotRemoveChild"
                  label="Explain why the child has not been removed from the area"
                  placeholder="Explanation"
                  register={register}
                  error={errors.reasonNotRemoveChild}
                />
              )}
            </>
          )}
        </>
      )}

      {hasNoIdCustomerDescription && (
        <TextareaComponent
          name="customerDescription"
          label="Capture description of customer with no ID"
          placeholder="Description"
          register={register}
          error={errors.customerDescription}
        />
      )}

      <ToggleComponent
        control={control}
        name="hasGambled"
        label="Did they gamble before challenged?"
        error={errors.hasGambled}
      />
      {hasGambled && (
        <ToggleComponent
          control={control}
          name="hasHadStakeReturned"
          label="Confirm their stake has been returned"
          error={errors.hasHadStakeReturned}
        />
      )}
      <ToggleComponent
        control={control}
        name="hasBeenRefusedEntry"
        label="Confirm the customer has been refused entry"
        error={errors.hasBeenRefusedEntry}
      />
    </>
  );
};

export default CustomerHasNoIdForm;
